<template>
  <div
    id="kt_modal_solicitar_movimentacao_boleto"
    ref="kt_modal_solicitar_movimentacao_boleto"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3 bg-light">
          <h4 class="modal-title">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Solicitar movimentação
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              v-if="this.errosGerais && this.errosGerais.Message"
              class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
            >
              <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <inline-svg src="media/icons/duotune/general/gen044.svg" />
              </span>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                  <div class="fs-6 text-gray-600">
                    {{ this.errosGerais.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="required form-label">Data Inicial</label>
              <el-date-picker
                :id="`dataInicial`"
                v-model.sync="this.dataInicial"
                type="datetime"
                name="dtpDataInicial"
                placeholder="Selecione uma data"
                format="DD/MM/YYYY"
                size="large"
                @change="this.preencherData()"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dataInicial"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-2"
            >
              <label class="required form-label">Data Final</label>
              <el-date-picker
                :id="`dataFinal`"
                v-model.sync="this.dataFinal"
                type="datetime"
                name="dtpDataFinal"
                placeholder="Selecione uma data"
                format="DD/MM/YYYY"
                size="large"
                @change="this.preencherData()"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["dataFinal"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalSolicitarMovimentacao'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingModalSolicitarMovimentacao === true"
  ></LoadingModal>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
const toast = useToast();
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";

export default {
  emits: [
    "exibirSolicitarMovimentacaoModal",
    "confirmarSolicitarMovimentacaoModal",
  ],
  components: { LoadingModal },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if ((await this.validar()) === true) {
        try {
          await this.exibirModalLoading(true);
          this.mensagemLoading = "Aguarde, consultando movimentações";

          let retPost = await this.$store.dispatch(
            "licencaRecebivel/postSolicitarMovimentacao",
            "?dataInicial=" +
              this.$utils.formatarDataHoraConsulta(this.dataInicial) +
              "&dataFinal=" +
              this.$utils.formatarDataHoraConsulta(this.dataFinal)
          );

          if (retPost.Success === true) {
            let confirmar = await Swal.fire({
              text: retPost.Message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-success",
              },
            });

            if (confirmar.isConfirmed) {
              await this.exibirModalLoading(false);
              this.loading = false;

              this.$emit("confirmarSolicitarMovimentacaoModal", false);
              hideModal(this.$refs.kt_modal_solicitar_movimentacao_boleto);
            }
          } else {
            await Swal.fire({
              text: retPost.Message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-danger",
              },
            });
          }
        } catch (error) {
          let msgErro = await Swal.fire({
            text: error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-danger",
            },
          });
          if (msgErro.isConfirmed) {
            this.errosValidacao = error;
            await this.exibirModalLoading(false);
          }
        }
      } else {
        await Swal.fire({
          text: "Verifique os avisos antes de prosseguir!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-warning",
          },
        });
      }
      this.loading = false;
    },
    async validar() {
      this.errosGerais = [];

      if (!this.dataInicial) {
        this.errosGerais.Message = "A data inicial deve ser informada!";
        return false;
      } else if (this.dataFinal <= 0) {
        this.errosGerais.Message = "A data final deve ser informada!";
        return false;
      } else {
        const dataFinalEsperada = new Date(this.dataInicial);
        dataFinalEsperada.setDate(dataFinalEsperada.getDate() + 2);
        if (this.dataFinal <= dataFinalEsperada) {
          return true;
        } else {
          this.errosGerais.Message =
            "A data final deve ser no máximo dois dias após a data inicial!";
          return false;
        }
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_solicitar_movimentacao_boleto);
      this.$emit("exibirSolicitarMovimentacaoModal", false);
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loadingModalSolicitarMovimentacao = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalSolicitarMovimentacao");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalSolicitarMovimentacao");
        await this.sleep(100);
        this.loadingModalSolicitarMovimentacao = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    preencherData() {
      if (this.dataInicial) {
        const novaDataFinal = new Date(this.dataInicial);
        novaDataFinal.setDate(novaDataFinal.getDate() + 2);
        this.dataFinal = novaDataFinal;
      }
    },
  },
  async mounted() {
    this.errosValidacao = [];
    this.errosGerais = [];
    this.preencherData();
  },
  data() {
    return {
      errosGerais: [],
      errosValidacao: [],
      loading: false,
      dataInicial: new Date(),
      dataFinal: new Date(),
      loadingModalSolicitarMovimentacao: false,
      mensagemLoading: "",
    };
  },
};
</script>

<style></style>
